<script setup lang="ts"></script>

<template>
  <h2 class="text-lg font-bold leading-6">
    <slot></slot>
  </h2>
</template>
